import React, { Fragment, useContext, useEffect, useState } from 'react';
import './TeacherHomePageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import TableProviderSchools from "root/Tables/TableProviderSchools";
import {getProvidersForUser} from "root/DataFunctions/ProviderFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import GlobalContext, { useGlobalContext } from "root/Contexts/GlobalContext";
import { ConfigOptions } from "root/Contexts/GlobalProvider";

const TeacherHomePageBody = () =>
{
    const [data, setData] = useState({loading: true, data: []});
    const sessionContext = useContext( GlobalContext ) ;

    const { current_academic_year } = useGlobalContext() ;

    useEffect(() => {
        getData();
    }, []);

    const getData = () =>
    {
        getProvidersForUser( 'current', (response) =>
        {
            const returnData = getDataFromResponse(response) ;

            setData({loading: false, data: returnData})
        })
    }

    const introPage = sessionContext.getHomePageIntro() ;

    const titlePage = sessionContext.getCustomObject( ConfigOptions.HOME_PAGE_TITLE ) ;

    const survey_type = sessionContext.getCurrentSurveyType() ;

    const academicYearRangeStr = current_academic_year + ' - ' + (current_academic_year+1) ;

    return (
        <Fragment>
           <PageBodyWrapper title={ titlePage} >
            <div className='sections-grid-rows'>
                <div className='table-section-rows'>
                    <h5>Self Evaluation { academicYearRangeStr }</h5>
                    <div className='intro-page'>
                        { introPage }
                    </div>
                   <div/>
                    <div style={{marginBottom:'40px'}}/>
                    <TableProviderSchools data={data} survey_type={survey_type}/>
                </div>
            </div>
            </PageBodyWrapper>
        </Fragment>
    )
}

export default TeacherHomePageBody;
